module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFISURBVGiB7ZrBDcIwDEW/UfciTNAeMkg2gG7AIBxgAsJk5QKHVrikiePKUt7VwbUl/3xMITD0PjwBOC6eAgGn++0aS3L841AzuQatgb2hwYfLr8AEnGcHE+Z5qRsCxvIS1+mWhUpSM/cX8yNkvoEOQGRiTiA/l1sM4gI5gswRfild6kENQeZgXgPmG2BHiIDXpFlJo7EPrA9I8fGTIggYOT9J9oECnEAO1kTNX6PmG6DBB1fzARMw0wABp4zPjGC+GFLvg6pfPW7XvxfHlprMj5D5BtYWGimcQI7IBTSMbDbPmSJmFyMNI5uxLK4U8xow34DGCEWFZzQaubA+MPhwmYBjYXJ2EZGCFfGneFeYv/rP6+avUfMNbPGBSMBr7YDQ2G0ieaHJecWkgfkRag3sTcct2Vb+arDlDc2z96FmLVmYH6HWwN68AQeGVig6fN+0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/homedata_jzjl.png
// module id = utMz
// module chunks = 3